"use client";

import React, {useState, useRef, useEffect} from 'react';
import getMachineList from '@/services/OrderService/getMachineList';


const GrafanaDashboard = () => {
    // The URL for your Grafana dashboard

    const [machineList, setMachineList] = useState<any[]>([]);
    const [selectedMachine, setSelectedMachine] = useState<string | null>(null);

    const NEATOLABS_MAC = '9c:95:6e:a0:cf:03';

    const updateMachineList =  async () => {
        const machineList = await getMachineList();
        setMachineList(machineList || []);
        if (machineList && machineList.length > 0) {
            const neatolabs = machineList.find((m: any) => m.mac_address === NEATOLABS_MAC);
            setSelectedMachine(neatolabs ? neatolabs.mac_address : machineList[0].mac_address);
        }
    }


    useEffect(() => {
        updateMachineList();
    }, []);


    const grafanaUrl = `https://analytics.lumialase.com/d/3e363336-4349-4d1f-abca-84d5071b5a8d/machine-analytics?orgId=1&from=2026-04-16T19:30:00.000Z&to=2026-04-16T21:59:59.000Z&timezone=browser&var-machine_mac=${selectedMachine}`;

    // Step 1: Create a ref to get a direct reference to our container element
    const containerRef = useRef<HTMLDivElement>(null);

    // Step 2: Create a state to track if we are in fullscreen mode
    const [isFullScreen, setIsFullScreen] = useState(false);

    // Step 3: Create the function that toggles fullscreen
    const toggleFullScreen = () => {
        // Check if the browser is NOT currently in fullscreen mode
        if (!document.fullscreenElement) {
            // If not, we request fullscreen on our container element
            containerRef.current?.requestFullscreen();
        } else {
            // If it is, we exit fullscreen
            document.exitFullscreen();
        }
    };

    // Step 4: Use an effect to sync our state with the browser
    // This handles the user pressing the "Esc" key to exit fullscreen
    useEffect(() => {
        const onFullScreenChange = () => {
            setIsFullScreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', onFullScreenChange);
        // Cleanup the event listener when the component is removed
        return () => document.removeEventListener('fullscreenchange', onFullScreenChange);
    }, []);

    return (
        // We attach the ref here. This div and everything inside it will become fullscreen.
        // The inline style provides the default size.
        <div ref={containerRef} style={{width: '100%', height: '100vh', background: 'white'}}>

            {/* --- Fullscreen Checkbox --- */}
            <div style={{padding: '10px'}}>
                <label>
                    <input
                        type="checkbox"
                        checked={isFullScreen}
                        onChange={toggleFullScreen}
                    />
                    Show Full Screen
                </label>
            </div>

            <iframe
                src={grafanaUrl}
                // The iframe height is adjusted to account for the checkbox above
                style={{width: '100%', height: 'calc(100% - 45px)', border: 'none'}}
                frameBorder="0"
                title="Lumia Lase Analytics Dashboard"
            ></iframe>
        </div>
    );
};

export default GrafanaDashboard;